import CrudAPI from '@/api/resources/crud'
import store from '@/store'
import axios from 'axios'

const userAPI = {
  // combine two legacy vars to one
  resource: 'users',
  url_query: '/api/users',

  auth (credentials) {
    let url = store.getters.config.api_host + store.getters.config.api_oauth_url_token

    return new Promise((resolve, reject) => {
      store.getters.axios.post(url, {
        username: credentials.userLogin,
        password: credentials.userPassword,
        client_id: store.getters.config.api_oauth_client_id,
        client_secret: store.getters.config.api_oauth_client_secret,
        grant_type: store.getters.config.api_oauth_grant_type,
        scope: store.getters.config.api_oauth_default_scope
      }).then(response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
    })
  },

  loadUsers () {
    return new Promise((resolve, reject) => {
      let users = CrudAPI.dfsResourceIndex('users')

      users.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  getStats () {
    return new Promise((resolve, reject) => {
      store.getters.axios.get(store.getters.config.api_host + '/api/user/stats').then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  loadCaseManagers () {
    return new Promise((resolve, reject) => {
      let users = CrudAPI.dfsResourceIndex('users/casemanagers')

      users.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadUser (userId) {
    return new Promise((resolve, reject) => {
      let user = CrudAPI.dfsResourceShow('users', userId)

      user.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadVendors () {
    return new Promise((resolve, reject) => {
      let users = CrudAPI.dfsResourceIndex('users/vendors')

      users.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  getLinkedRoles (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/roles'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getLinkedInventories (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/inventories'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getLinkedServices (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/services'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getLinkedProducts (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/products'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getCaseManagersLinkedCasesAndProducts (itemId) {
    let url = store.getters.config.api_host + this.url_query + '/' + itemId + '/casemanager/cases/products'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getCurrentUser () {
    let url = store.getters.config.api_host + this.url_query + '/current'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  getCurrentUserRoles () {
    let url = store.getters.config.api_host + this.url_query + '/current/roles'

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  add (payload) {
    return new Promise((resolve, reject) => {
      let result = CrudAPI.dfsResourceStore(this.resource + '/withid', payload)

      result.then(result => {
        resolve(result.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  uploadAvatar (userId, event) {
    return new Promise((resolve, reject) => {
      let form = new FormData()
      let result = null

      form.append('avatar', event.target.files[0])

      result = axios.post(store.getters.config.api_host + '/api/' + this.resource + '/' + userId + '/avatar', form, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      result.then(result => {
        resolve(result.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  }
}

export default userAPI



// WEBPACK FOOTER //
// ./src/api/user.js